
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Button',
    props: {
        variant: String,
        to: String,
        href: String,
    },
})
